/* eslint-disable react/no-danger */
import Head from 'next/head';
import { Col, Container, Row } from 'reactstrap';

import Layout from '../../components/layout/layout';
import PrivacyJp from '../../components/pages/privacy-jp';
import useI18n from '../../hooks/use-i18n';
import { languages, contentLanguageMap } from '../../language.config';
import getTranslationKeys, { PAGEID } from '../../utils/i18nRosseta';

import '../../styles/privacy.scss';

const sections = [
  'section_one',
  'section_two',
  'section_three',
  'section_four',
  'section_five',
  'section_six',
  'section_seven',
  'section_eight',
  'section_nine',
  'section_ten'
];

const Privacy = () => {
  const i18n = useI18n();
  const privacy = i18n.t('privacy');
  const codes = i18n.activeLocale.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';
  const pageMetaData = i18n.t('metadata').privacy_policy;

  return (
    <Layout
      page="privacy"
      description={pageMetaData.description}
      title={pageMetaData.title}
      keywords={pageMetaData.keywords}
      analyticData={{ name: 'Privacy Policy', properties: { } }}
      pageUrl="privacy"
      pageEnabledMarkets={[]}
    >
      <Head />
      {country !== 'jp' ? (
        <section className="content-page-wrapper pagetop-headerspace">
          <Container>
            <Row>
              <Col xl={{ size: 8, order: 2, offset: 2 }}>
                <h1>{privacy.title}</h1>
                <div dangerouslySetInnerHTML={{ __html: privacy.first_para }} />
                <ol>
                  {sections.map((section) => <div dangerouslySetInnerHTML={{ __html: privacy[section] }} />)}
                </ol>
              </Col>
            </Row>
          </Container>
        </section>
      ) : (
        <PrivacyJp />
      )}

    </Layout>
  );
};

export async function getStaticProps({ params }) {
  const lngDict = {};
  const pageId = PAGEID.PRIVACY;
  const keys = getTranslationKeys(pageId);
  const { default: lngDictAll = {} } = await import(
    `../../locales/${contentLanguageMap[params.lng]}.json`
  );
  keys.forEach((data) => {
    lngDict[data] = lngDictAll[data];
  });
  return {
    props: { lng: params.lng, lngDict, pageId }
  };
}

export async function getStaticPaths() {
  return {
    paths: languages.map((l) => ({ params: { lng: l } })),
    fallback: false
  };
}

export default Privacy;
